import debounce from 'lodash/debounce';
import { createDecorator } from 'vue-class-component';

export default function makeDecorator(duration) {
   return createDecorator(function _decorator(options, key) {
      const origin = options.methods[key];
      options.methods[key] = debounce(function _notDebounced(...args) {
         // eslint-disable-next-line no-invalid-this
         origin.apply(this, args);
      }, duration);
   });
}
